module.exports = __webpack_public_path__ + "static/blog-img2-d7f2102ba98bbe3326709dd8d8d1907a.jpg";